import ChangePassword from "../Sigin&SignUp/ChangePassword";

export const masterAPI = {
  assetCategory: {
    title: "Asset Category",
    link: "/assetcategory/getall",
    create: "/assetcategory/create",
    update: "/assetcategory/update",
    delete: "/assetcategory/delete",
    enable: "/assetcategory/enable",
    disable: "/assetcategory/disable",
  },
  criticality: {
    title: "Criticality",
    link: "/criticality/getall",
    create: "/criticality/create",
    update: "/criticality/update",
    delete: "/criticality/delete",
    enable: "/criticality/enable",
    disable: "/criticality/disable",
  },
  priority: {
    title: "Priority",
    link: "/priority/getall",
    create: "/priority/create",
    update: "/priority/update",
    delete: "/priority/delete",
    enable: "/priority/enable",
    disable: "/priority/disable",
  },
  assetStatus: {
    title: "Asset Status",
    link: "/assetstatus/getall",
    create: "/assetstatus/create",
    update: "/assetstatus/update",
    delete: "/assetstatus/delete",
    enable: "/assetstatus/enable",
    disable: "/assetstatus/disable",
  },
  assetType: {
    title: "Asset Type",
    link: "/assettype/getall",
    create: "/assettype/create",
    update: "/assettype/update",
    delete: "/assettype/delete",
    enable: "/assettype/enable",
    disable: "/assettype/disable",
  },
  warranty: {
    title: "Warranty",
    link: "/warranty/getall",
    create: "/warranty/create",
    update: "/warranty/update",
    delete: "/warranty/delete",
  },
  locationType: {
    title: "Location Type",
    link: "/locationtype/getall",
    create: "/locationtype/create",
    update: "/locationtype/update",
    delete: "/locationtype/delete",
    enable: "/locationtype/enable",
    disable: "/locationtype/disable",
  },
  location: {
    title: "Location",
    link: "/location/getall",
    getbyid: "/location/getbyid",
    create: "/location/create",
    update: "/location/update",
    delete: "/location/delete",
    enable: "/location/enable",
    disable: "/location/disable",
    treeView: "/location/treeview",
  },
  technicalSpecification: {
    title: "Technical Specification",
    link: "/technicalspec/getall",
    create: "/technicalspec/create",
    update: "/technicalspec/update",
    delete: "/technicalspec/delete",
    assetTechSpec: "/technicalspec/getbyasset",
    enable: "/technicalspec/enable",
    disable: "/technicalspec/disable",
  },
  assetTechSpec: {
    create: "/assettechspec/create",
    delete: "/assettechspec/delete",
    getByAssetId: "/assettechspec/getbyassetid",
    bulkinsert: "/assettechspec/bulkinsert",
  },
  parttechspec: {
    create: "/parttechspec/create",
    delete: "/parttechspec/delete",
    getByPartId: "/parttechspec/getbypartid",
    bulkinsert: "/parttechspec/bulkinsert",
  },
  technicalAttributes: {
    title: "Technical Attributes",
    link: "/technicalattributes/getall",
    create: "/technicalattributes/create",
    update: "/technicalattributes/update",
    delete: "/technicalattributes/delete",
    getByTechSpecId: "/techspecattributes/getbytechspecid",
    enable: "/technicalattributes/enable",
    disable: "/technicalattributes/disable",
  },
  uom: {
    title: "UOM",
    link: "/uom/getall",
    create: "/uom/create",
    update: "/uom/update",
    delete: "/uom/delete",
    enable: "/uom/enable",
    disable: "/uom/disable",
  },
  business: {
    title: "Business",
    link: "/business/getall",
    create: "/business/create",
    update: "/business/update",
    delete: "/business/delete",
    enable: "/business/enable",
    disable: "/business/disable",
  },
  failureClass: {
    title: "Failure Class",
    link: "/failureclass/getall",
    create: "/failureclass/create",
    update: "/failureclass/update",
    delete: "/failureclass/delete",
    enable: "/failureclass/enable",
    disable: "/failureclass/disable",
  },
  failureCode: {
    title: "Failure Code",
    link: "/failurecode/getall",
    create: "/failurecode/create",
    update: "/failurecode/update",
    delete: "/failurecode/delete",
  },
  meterGroup: {
    title: "Meter Group",
    link: "/metergroup/getall",
    create: "/metergroup/create",
    update: "/metergroup/update",
    delete: "/metergroup/delete",
    getMGByMeter: "/metergroup/getbymeterid",
    enable: "/metergroup/enable",
    disable: "/metergroup/disable",
  },
  meter: {
    title: "Meter",
    link: "/meter/getall",
    create: "/meter/create",
    update: "/meter/update",
    delete: "/meter/delete",
    getMeterByAsset: "/assetsmeter/getmetersbyasset",
    enable: "/meter/enable",
    disable: "/meter/disable",
  },
  stockCategory: {
    title: "Stock Category",
    link: "/stockcategory/getall",
    create: "/stockcategory/create",
    update: "/stockcategory/update",
    delete: "/stockcategory/delete",
    enable: "/stockcategory/enable",
    disable: "/stockcategory/disable",
  },
  stockRoom: {
    title: "Stock Room",
    link: "/stockroom/getall",
    create: "/stockroom/create",
    update: "/stockroom/update",
    delete: "/stockroom/delete",
    enable: "/stockroom/enable",
    disable: "/stockroom/disable",
  },
  stockRoomAisleRow: {
    title: "Stock Room Aisle Rows",
    link: "/stockroomaislerows/getbyaisle",
    create: "/stockroomaislerows/create",
    update: "/stockroomaislerows/update",
    delete: "/stockroomaislerows/delete",
    enable: "/stockroomaislerows/enable",
    disable: "/stockroomaislerows/disable",
  },
  stockRoomRowBin: {
    title: "Stock Room Bins",
    link: "/stockroomrowbins/getbystockroomrow",
    create: "/stockroomrowbins/create",
    update: "/stockroomrowbins/update",
    delete: "/stockroomrowbins/delete",
    enable: "/stockroomrowbins/enable",
    disable: "/stockroomrowbins/disable",
  },
  stockRoomAisle: {
    title: "Stock Room Aisles",
    link: "/stockroomaisles/getbystockroom",
    create: "/stockroomaisles/create",
    update: "/stockroomaisles/update",
    delete: "/stockroomaisles/delete",
    enable: "/stockroomaisles/enable",
    disable: "/stockroomaisles/disable",
  },
  partsGroup: {
    title: "Part Group",
    link: "/partsgroup/getall",
    create: "/partsgroup/create",
    update: "/partsgroup/update",
    delete: "/partsgroup/delete",
    enable: "/partsgroup/enable",
    disable: "/partsgroup/disable",
  },
  labour: {
    title: "Labour",
    link: "/labours/getall",
    create: "/labours/create",
    update: "/labours/update",
    delete: "/labours/delete",
    enable: "/labours/enable",
    disable: "/labours/disable",
  },
  crafts: {
    title: "Crafts",
    link: "/crafts/getall",
    create: "/crafts/create",
    update: "/crafts/update",
    delete: "/crafts/delete",
    enable: "/crafts/enable",
    disable: "/crafts/disable",
  },
  labourCraft: {
    title: "Labour Craft",
    link: "/labourcraft/getall",
    create: "/labourcraft/create",
    update: "/labourcraft/update",
    delete: "/labourcraft/delete",
    enable: "/labourcraft/enable",
    disable: "/labourcraft/disable",
    craftBylabour: "/labourcraft/craftbylabourid",
    getallbyworkcenterid: "/labourcraft/getallbyworkcenterid",
    getallbyworkcenterids: "/labourcraft/getallbyworkcenterids",
    getlaboursbyworkcenters: "/labours/getlaboursbyworkcenters",
  },
  person: {
    title: "Person",
    link: "/person/getall",
    create: "/person/create",
    update: "/person/update",
    delete: "/person/delete",
    getByid: "/person/getbyid",
    enable: "/person/enable",
    disable: "/person/disable",
    getallForSystemAdmin: "/person/getallForSystemAdmin",
    getbyidAdmin: "/person/getbyidAdmin",
  },
  roles: {
    title: "Roles",
    link: "/roles/getall",
    create: "/roles/create",
    update: "/roles/update",
    delete: "/roles/delete",
    enable: "/roles/enable",
    disable: "/roles/disable",
    getallBySiteId: "/roles/getallBySiteId",
    getByOrgId: "/roles/getByOrgId",
  },
  workCenter: {
    title: "Work Center",
    link: "/workcenter/getall",
    create: "/workcenter/create",
    update: "/workcenter/update",
    delete: "/workcenter/delete",
    enable: "/workcenter/enable",
    disable: "/workcenter/disable",
    getById: "/workcenter/getbyid",
  },
  workCenterLabour: {
    title: "Work Center Labour",
    link: "/workcenterlabour/getall",
    create: "/workcenter/create",
    update: "/workcenter/update",
    delete: "/workcenterlabour/delete",
    labourByWorkCenter: "/api/selectlist/GetWorkCenterMappedLabour",
  },
  workFlow: {
    title: "Work Flow",
    link: "/workflow/getall",
    create: "/workflow/create",
    update: "/workflow/update",
    delete: "/workflow/delete",
    enable: "/workflow/enable",
    disable: "/workflow/disable",
  },
  workFlowApproval: {
    title: "Work Flow Approval",
    link: "/updateworkflow/getallbyuser",
    update: "/updateworkflow/update",
  },
  assets: {
    title: "Assets",
    link: "/assets/getall",
    create: "/assets/create",
    update: "/assets/update",
    delete: "/assets/delete",
    getById: "/assets/getbyid",
    treeView: "/assets/treeview",
    getalltreeview: "/assets/getalltreeview",
    changeStatus: "/assets/changestatus",
    assetLogByid: "/assets/getlogsbyassetid",
    assetByLocation: "/assets/getassetsbylocation",
    enable: "/assets/enable",
    disable: "/assets/disable",
    getCost: "/assets/getltdcostid",
    getMTBF: "/assets/getassetmtbf",
    assetYTDCost: "/assets/getytdcostid",
    getAssetByLocAndAssettype: "/assets/getallassetbylocationandtype",
    downloadAllQrcodes: "/assets/downloadAllQrcodes",
    downloadAllQrcodesPdf: "assets/downloadAllQrcodesPdf",
  },
  assetLogs: {
    title: "Asset Log",
    getById: "/assetlogs/getallbyassetid",
    delete: "/assetlogs/delete",
    getallbyDocLogAssetid: "/assetlogs/getallbyDocLogAssetid",
  },
  assetPart: {
    link: "/assetparts/getall",
    create: "/assetparts/create",
    update: "/assetparts/update",
    delete: "/assetparts/delete",
    assetParts: "/assetparts/partsbyassetid",
    bulkinsert: "/assetparts/bulkinsert",
  },
  menus: {
    title: "Menus",
    link: "/menus/getall",
    create: "/menus/create",
    update: "/menus/update",
    delete: "/menus/delete",
    enable: "/menus/enable",
    disable: "/menus/disable",
    getByOrgId: "/menus/getallByOrg",
    getBySitId: "/menus/getallBySite",
    getMasterMenus: "/menus/getMasterMenus",
    getMasterMenusOrg: "/menus/getMasterMenusOrg",
    getallMenuByOrgid: "/orgMenus/getall",
    getAllMenusSelectList: "/selectlist/getallmenus",
  },
  roleMenu: {
    title: "Role Rights",
    link: "/rolemenus/getall",
    create: "/rolemenus/create",
    update: "/rolemenus/update",
    delete: "/rolemenus/delete",
    bulkinsert: "/rolemenus/bulkinsert",
    getbyRoleId: "/rolemenus/getMenusbyOrgSiteRoleIds",
  },
  parts: {
    title: "Parts",
    link: "/parts/getall",
    create: "/parts/create",
    update: "/parts/update",
    delete: "/parts/delete",
    enable: "/parts/enable",
    disable: "/parts/disable",
    getById: "/parts/getById",
    getBusinessByPartId: "/businessparts/businessbypartid",
  },
  workOrder: {
    title: "Work Order",
    link: "/workorder/getall",
    create: "/workorder/create",
    update: "/workorder/update",
    delete: "/workorder/delete",
    search: "/workorder/search",
    getbyid: "/workorder/getbyid",
    getDocumentbyworkOrderId: "/workorder/getdocumentbyworkorderid",
    changeStatus: "/workorder/updatestatus",
    completeDetail: "/workorder/getcompletedetails",
    linkedRec: "/workorder/getlinkedrecords",
    uploadDoc: "/workorder/uploaddocument",
    deleteDoc: "/workorder/deletedocument",
    download: "/workorder/downloaddocument",
    enable: "/workorder/enable",
    disable: "/workorder/disable",
    getByServiceReqId: "/workorder/getbyservicereqid",
    getLogs: "/workorder/getlogs",
    updateWorkcenter: "/workorder/updateworkcenter",
    getWOPartByWOId: "/workorderparts/getall",
    workOrderPartBulkInsert: "/workorderparts/bulkinsert",
    workOrderPartUpdate: "/workorderparts/update",
    workOrderPartDelete: "/workorderparts/delete",
    costSummaryDetail: "/workorder/getCostdetails",
  },
  jobPlan: {
    title: "Job Plan",
    link: "/jobplan/getall",
    create: "/jobplan/create",
    update: "/jobplan/update",
    delete: "/jobplan/delete",
    getByid: "/jobplan/getbyid",
    completeDetail: "/jobplan/getcompletedetails",
    enable: "/jobplan/enable",
    disable: "/jobplan/disable",
  },
  selectList: {
    assetStatus: "/selectlist/assetsstatuses",
    jobPlanStatus: "/selectlist/jobplanstatus",
    jobPriority: "/selectlist/jobpriority",
    taskStatus: "/selectlist/taskstatus",
    taskTypes: "/selectlist/tasktypes",
    failureCodeType: "/selectlist/failurecodetypes",
    woStatus: "/selectlist/wostatus",
    pmStatus: "/selectlist/pmstatus",
    pmJobType: "/selectlist/pmjobtype",
    frequencyunitsfortime: "/selectlist/frequencyunitsfortime",
    frequencyunitsformeter: "/selectlist/frequencyunitsformeter",
    workordertype: "/selectlist/worktype",
    problem: "/selectlist/problems",
    documentType: "/selectlist/documenttypes",
    documentcategories: "selectlist/documentcategories",
    causes: "/selectlist/causes",
    remedy: "/selectlist/remedy",
    pmScheduleType: "/selectlist/pmscheduletypes",
    technicalSpecificationType: "/selectlist/technicalspecificationtypes",
    stockRoom: "/selectlist/stockroom",
    stockRoomAisle: "/selectlist/stockroomaisle",
    stockRoomAisleRow: "/selectlist/stockroomrows",
    stockRoomAisleRowBin: "/selectlist/stockroomrowbins",
    stockRoomByPart: "/selectlist/stockroombypart",
    aisleByPartAndRoom: "/selectlist/aislesbypartandroom",
    rowByPartAndAisle: "/selectlist/rowsbypartandaisle",
    binByPartAndRow: "/selectlist/binsbypartandrow",
    techspecbyType: "/selectlist/techspecsbytype",
    businessType: "/selectlist/businesstype",
    businessByType: "/selectlist/businessbytype",
    partsCategory: "/selectlist/partscategory",
    inventoryusageStatus: "/selectlist/inventoryusagestatus",
    criticalitybyType: "/selectlist/criticalities",
    serviceRequestStatus: "/selectlist/servicerequeststatus",
    uomCategory: "/selectlist/uomcategory",
    uomByCat: "/selectlist/uombycategory",
    questionType: "/selectlist/questiontype",
    partsInventory: "/selectlist/partinventoryparts",
    notificationType: "/selectlist/notificationType",
    metertypes: "/selectlist/metertypes",
    getRoles: "/selectlist/getroles",
    getrolesbyOrgId: "/selectlist/getrolesbyOrgId",
    workflowByTypes: "/selectlist/workflowbytypes",
    workflowLevels: "/selectlist/workflowlevels",
    getUsersByRole: "/selectlist/getusersbyrole",
    getpersons: "/selectlist/persons",
    getAttributeValueType: "/selectlist/getattributevaluetypes",
    workordersbyStatus: "/selectlist/workordersbyStatus",
    timeZones: "/selectlist/gettimezones",
    getAllTimeZones: "/selectlist/getalltimezones",
  },
  assetDocument: {
    getDocumentbyassetId: "/assetdocument/getbyassetid",
    uploadDoc: "/assetdocument/upload",
    delete: "/assetdocument/delete",
    download: "/assetdocument/download",
  },
  assetMovement: {
    create: "/assetmovement/create",
    title: "Asset Transfer Log",
    getByAssetId: "/assetmovement/getallbyassetid",
    delete: "/assetmovement/delete",
  },
  user: {
    signin: "users/signin",
    signout: "users/signout",
    getUserBySite: "/users/getusersbysite",
    addroletouser: "/users/addroletouser",
    updateRoleToUser: "/users/updateRoleToUser",
    forgotEmail: "/users/forgotpassword",
    changePassword: "/users/changepassword",
    getById: "/users/getbyid",
  },
  jobPlanTask: {
    getByJobPlanId: "/jobplantask/getall",
    create: "/jobplantask/create",
    delete: "/jobplantask/delete",
    update: "/jobplantask/update",
  },
  workOrderTask: {
    getByWorkOrderId: "/workordertask/getall",
    getById: "/workordertask/getbyid",
    create: "/workordertask/create",
    update: "/workordertask/update",
    delete: "/workordertask/delete",
    bulkinsert: "/workordertask/bulkinsert",
    bulkupdate: "/workordertask/bulkstatusupdate",
    upload: "/workordertask/uploaddocument",
  },
  workOrderTaskLabour: {
    create: "/workordertasklabour/create",
    bulkinsert: "/workordertasklabour/bulkinsert",
    update: "/workordertasklabour/update",
    delete: "/workordertasklabour/delete",
    updateplannedHrs: "/workordertasklabour/updatehrsandcost",
    labourSchedule: "/workordertasklabour/getLabourScheduleList",
    getalllabour: "/workordertasklabour/getalllabour",
    bulkupdate: "/workordertasklabour/bulkupdate",
    bulkstatusupdate: "/workordertasklabour/bulkstatusupdate",
  },
  jobPlanTaskLabour: {
    create: "/jobplantasklabour/create",
    bulkinsert: "/jobplantasklabour/bulkinsert",
    update: "/jobplantasklabour/update",
    delete: "/jobplantasklabour/delete",
  },
  workOrderTaskPart: {
    create: "/workordertaskparts/create",
    update: "/workordertaskparts/update",
    delete: "/workordertaskparts/delete",
    bulkinsert: "/workordertaskparts/bulkinsert",
  },
  jobPlanTaskParts: {
    create: "/jobplantaskparts/create",
    update: "/jobplantaskparts/update",
    delete: "/jobplantaskparts/delete",
    bulkinsert: "/jobplantaskparts/bulkinsert",
  },
  PM: {
    title: "PM Schedule",
    link: "/pmaintenace/getall",
    create: "/pmaintenace/create",
    update: "/pmaintenace/update",
    delete: "/pmaintenace/delete",
    getByid: "/pmaintenace/getbyid",
    getdocbyid: "/pmaintenace/getdocumentbypmid",
    uploadDoc: "/pmaintenace/uploaddocument",
    deleteDoc: "/pmaintenace/deletedocument",
    download: "/pmaintenace/downloaddocument",
    generateWO: "/pmaintenace/generateworkorderbylistofids",
    enable: "/pmaintenace/enable",
    disable: "/pmaintenace/disable",
    generateworkorderbymeterbase: "/pmaintenace/generateworkorderbymeterbase",
  },
  serviceRequest: {
    title: "Service Request",
    link: "/servicerequest/getall",
    create: "/servicerequest/create",
    update: "/servicerequest/update",
    delete: "/servicerequest/delete",
    getByid: "/servicerequest/getbyid",
    coverttowo: "/servicerequest/converttoworkorder",
    getdocbyid: "/servicerequest/getdocumentbysrid",
    uploadDoc: "/servicerequest/uploaddocument",
    deleteDoc: "/servicerequest/deletedocument",
    download: "/servicerequest/downloaddocument",
    updateStatus: "/servicerequest/updatestatus",
    enable: "/servicerequest/enable",
    disable: "/servicerequest/disable",
  },
  site: {
    title: "Site",
    link: "/site/getall",
    getallByOrgid: "/site/getallByOrgid",
    create: "/site/create",
    update: "/site/update",
    delete: "/site/delete",
    getByid: "/site/getbyid",
    enable: "/site/enable",
    disable: "/site/disable",
  },
  import: {
    cloneapplicationroles: "/import/cloneapplicationroles",
    cloneMenusForOraAdmin: "/import/cloneMenusForOraAdmin",
    cloneRoleMenuForOraAdmin: "/import/cloneRoleMenuForOraAdmin",
    cloneMenusForSiteAdmin: "/import/cloneMenusForSiteAdmin",
    uploadMasters: "/import/upload/masters",
    uploadAssets: "/import/upload/assets",
    uploadPmschedule: "/import/upload/Pmschedule",
    uploadLocationmaster: "/import/upload/locationmaster",
    uploadParts: "/import/upload/parts",
    uploadStockroom: "/import/upload/stockroom",
  },
  businessCraft: {
    title: "Business Craft",
    link: "/businesscraft/getall",
    create: "/businesscraft/create",
    update: "/businesscraft/update",
    delete: "/businesscraft/delete",
    enable: "/businesscraft/enable",
    disable: "/businesscraft/disable",
    craftByBusiness: "/businesscraft/craftbybusinessid",
    getallbyworkcenterid: "/businesscraft/getallbyworkcenterid",
    getallbyworkcenterids: "/businesscraft/getallbyworkcenterids",
    getbusinessbyworkcenters: "/business/getbusinessbyworkcenters",
  },
  problems: {
    title: "Problem",
    link: "/problems/getall",
    create: "/problems/create",
    update: "/problems/update",
    delete: "/problems/delete",
    problembyFailureClass: "/problems/getall",
    enable: "/problems/enable",
    disable: "/problems/disable",
  },
  Causes: {
    title: "Causes",
    link: "/causes/getall",
    create: "/causes/create",
    update: "/causes/update",
    delete: "/causes/delete",
    causesbyproblem: "/causes/getall",
    enable: "/causes/enable",
    disable: "/causes/disable",
  },
  Remedies: {
    title: "Correctives",
    link: "/remedy/getall",
    create: "/remedy/create",
    update: "/remedy/update",
    delete: "/remedy/delete",
    remdybycause: "/remedy/getall",
    enable: "/remedy/enable",
    disable: "/remedy/disable",
  },
  tasktype: {
    title: "Task Type",
    link: "/tasktype/getall",
    create: "/tasktype/create",
    update: "/tasktype/update",
    delete: "/tasktype/delete",
    enable: "/tasktype/enable",
    disable: "/tasktype/disable",
  },
  worktype: {
    title: "Work Type",
    link: "/worktype/getall",
    create: "/worktype/create",
    update: "/worktype/update",
    delete: "/worktype/delete",
    enable: "/worktype/enable",
    disable: "/worktype/disable",
  },
  TreeView: {
    location: "/location/treeview",
  },
  failureReport: {
    bulkinsert: "/failurereport/bulkinsert",
    getByWO: "/failurereport/getall",
  },
  inventoryCreation: {
    title: "Part Inventory",
    link: "/inventorycreation/getallinitialentry",
    create: "/inventorycreation/create",
    update: "/inventorycreation/update",
    delete: "/inventorycreation/delete",
    getAllInv: "inventorycreation/getallinventory",
  },
  receipt: {
    title: "Receipts",
    link: "/receipts/getall",
    create: "/receipts/createreceipt",
    update: "/receipts/updatereceipt",
    delete: "/receipts/deletereceipt",
    receiptList: "/receipts/getbyreceiptitemlist",
    delRecList: "/receipts/deletereceiptitem",
    enable: "/receipts/enablereceipt",
    disable: "/receipts/disablereceipt",
    enableItem: "/receipts/enablereceiptitem",
    disableItem: "/receipts/disablereceiptitem",
    getbyreceiptitemlistbypartid: "receipts/getbyreceiptitemlistbypartid",
  },
  issue: {
    title: "Issue Transaction",
    link: "/issue/getall",
    create: "/issue/createIssue",
    update: "/issue/updateIssue",
    delete: "/issue/deleteIssue",
    issueList: "/issue/getbyissueditemlist",
    delIssueList: "/issue/deleteIssueitem",
    updateStatus: "/issue/updateIssuestatus",
    bulkUpdateStatus: "/issue/bulkupdateIssue",
    getIssuedPartsbyWO: "/issue/getissueddpartsbyworkorder",
    enable: "/issue/enableIssue",
    disable: "issue/disableIssue",
    enableItem: "/issue/enableIssueitem",
    disableItem: "issue/disableIssueitem",
    getallCompleteIssueRecord: "issue/getallCompleteIssueRecord",
  },
  inventory: {
    partStockLevelTitle: "Part Inventory Bulk Update",
    getAll: "/inventory/getall",
    search: "/inventory/search",
    bulkupdate: "/inventory/bulkupdate",
    update: "/inventory/update",
    getbystockroom: "/inventory/getbystockroomid",
    getallinventoryadjlist: "/inventoryadjustment/getall",
    getallStockTakingList: "/inventoryadjustment/getallStockTakingList",
    bulkStockTaking: "/inventory/bulkStockTaking",
    bulkStockTakinUpdate: "/inventory/bulkStockTakinUpdate",
    getSaftStockLevel: "/inventory/getSaftStockLevel",
    getReOrderPoint: "/inventory/getReOrderPoint",
    getEOQValue: "/inventory/getEOQValue",
    getPartsReservationQuantity: "/inventory/GetPartsReservationQuantity",
  },
  issueReturn: {
    title: "Return Transaction",
    getAll: "/issuereturn/getall",
    create: "/issuereturn/createissuereturn",
    delete: "/issuereturn/deleteissuereturn",
    returnList: "/issuereturn/getbyissuereturnlist",
    delReturnList: "/issuereturn/deleteissuereturnitem",
    updateStatus: "/issuereturn/updateissuereturnstatus",
    enable: "/issuereturn/enableissuereturn",
    disable: "/issuereturn/disableissuereturn",
    enableItem: "/issuereturn/enableissuereturnitem",
    disableItem: "/issuereturn/disableissuereturnitem",
    getbyissuereturnlistbypartid: "/issuereturn/getbyissuereturnlistbypartid",
    getTransactionHistory: "/issue/GetTransactionHistory",
  },
  vendorReturn: {
    title: "Vendor Return Transaction",
    getAll: "/vendorreturn/getall",
    create: "/vendorreturn/createvendorreturn",
    delete: "/vendorreturn/deletevendorreturn",
    returnList: "/vendorreturn/getbyvendorreturnlist",
    delReturnList: "/vendorreturn/deletevendorreturnitem",
    enable: "/vendorreturn/enablevendorreturn",
    disable: "/vendorreturn/disablevendorreturn",
  },
  KPIReport: {
    getmtbfreport: "/kpireport/getmtbfreport",
    getmttrreport: "/kpireport/getmttrreport",
    getcomplaiancechart: "/kpireport/getcomplaiancechart",
    woBacklogAndOpenStatus: "/kpireport/getcompliancereportbystatus",
    serviceReqStatus: "/kpireport/getservicerequestreport",
    woCostandLabour: "/kpireport/getworkordercostreport",
    getFailureClass: "/kpireport/failurereportforfailures",
    getProblem: "/kpireport/failurereportforproblem",
    getCauses: "/kpireport/failurereportforcauses",
    getRemedies: "/kpireport/failurereportforremedy",
    getChartLocation: "/kpireport/getkpichartlocation",
    getCloseWOListWithLocation: "/workorder/searchcloseworkorder",
    getcompliancereportbystatuswolist:
      "/kpireport/getcompliancereportbystatuswolist",
    getcostreportforwolist: "/kpireport/getcostreportforwolist",
    getKPIReportComplaianceWOList: "/kpireport/getKPIReportComplaianceWOList",
    getservicerequestreportlist: "/kpireport/getservicerequestreportlist",
    getmtbfreportwoList: "/kpireport/getmtbfreportwoList",
    getmttrreportwoList: "/kpireport/getmttrreportwoList",
    failurereportforfailuresWOList: "/kpireport/failurereportforfailuresWOList",
    failurereportforproblemWOList: "/kpireport/failurereportforproblemWOList",
    failurereportforcausesWOList: "/kpireport/failurereportforcausesWOList",
    failurereportforremedyWOList: "/kpireport/failurereportforremedyWOList",
    getPreventiveMaintenanceHourKPIData:
      "/kpireport/GetPreventiveMaintenanceHourKPIData",
    getPredictiveMaintenanceHourKPIData:
      "/kpireport/GetPredictiveMaintenanceHourKPIData",
    getCorrectiveMaintenanceHourKPIData:
      "/kpireport/GetCorrectiveMaintenanceHourKPIData",
    getproactiveKPIData: "/kpireport/GetproactiveKPIData",
    getreactiveKPIData: "/kpireport/GetreactiveKPIData",
    getScheduleKPIData: "/kpireport/GetScheduleKPIData",
    getBacklogSizeKPIData: "/kpireport/GetBacklogSizeKPIData",
    getAcceptedWorkPercentageKPIData:
      "/kpireport/GetAcceptedWorkPercentageKPIData",
    GetreworkpercentageKPIData: "/kpireport/GetreworkpercentageKPIData",
    getKPIMaintenanceByWorkType: "/kpireport/getkpimaintenancebyworktype",
    getKPIMaintenance: "/kpireport/getkpimaintenance",
    getTotalRepairHours: "/kpireport/gettotalrepairhours",
    getPlanningAccuracy: "/kpireport/getplanningaccuracy",
  },
  organization: {
    title: "Organization",
    link: "/organization/getall",
    create: "/organization/create",
    update: "/organization/update",
    delete: "/organization/delete",
    enable: "/organization/enable",
    getById: "/organization/getbyid",
    disable: "/organization/disable",
  },
  techSpecAttr: {
    title: "Technical Specification Attributes",
    link: "/techspecattributes/getall",
    create: "/techspecattributes/create",
    update: "/techspecattributes/update",
    delete: "/techspecattributes/delete",
    getByTechSpecId: "/techspecattributes/getbytechspecid",
    clone: "/techspecattributes/clone",
  },
  assetMeter: {
    title: "Asset Meter",
    link: "/assetsmeter/getall",
    create: "/assetsmeter/create",
    update: "/assetsmeter/update",
    delete: "/assetsmeter/delete",
    enable: "/assetsmeter/enable",
    disable: "/assetsmeter/disable",
    createreading: "/assetsmeter/createmeterreading",
    search: "/assetsmeter/search",
  },
  srName: {
    title: "Service Request Name",
    link: "/servicerequestname/getall",
    create: "/servicerequestname/create",
    update: "/servicerequestname/update",
    delete: "/servicerequestname/delete",
    enable: "/servicerequestname/enable",
    disable: "/servicerequestname/disable",
  },
  userManagement: {
    title: "Users",
    getusersbysite: "/users/getusersbysite",
    register: "/users/register",
    update: "/users/update",
    delete: "/users/delete",
    enable: "/users/enable",
    disable: "/users/disable",
    getAll: "/users/getall",
  },
  inspectionCat: {
    title: "Inspection Category",
    link: "/inspectioncategory/getall",
    create: "/inspectioncategory/create",
    update: "/inspectioncategory/update",
    delete: "/inspectioncategory/delete",
    enable: "/inspectioncategory/enable",
    disable: "/inspectioncategory/disable",
  },
  question: {
    title: "Inspection Task",
    link: "/questionmaster/getall",
    create: "/questionmaster/create",
    update: "/questionmaster/update",
    delete: "/questionmaster/delete",
    enable: "/questionmaster/enable",
    disable: "/questionmaster/disable",
  },
  assetTypeQuestion: {
    title: "Asset Type Inspection Task",
    link: "/assettypequestions/getall",
    create: "/assettypequestions/create",
    update: "/assettypequestions/update",
    delete: "/assettypequestions/delete",
    enable: "/assettypequestions/enable",
    disable: "/assettypequestions/disable",
    getByAssetTypeId: "/assettypequestions/getquestionsbyassetypeid",
  },
  route: {
    title: "Route",
    link: "/routemaster/getall",
    create: "/routemaster/create",
    update: "/routemaster/update",
    delete: "/routemaster/delete",
    enable: "/routemaster/enable",
    disable: "/routemaster/disable",
  },
  assetRoute: {
    title: "Asset Route",
    link: "/assetsroute/getall",
    getByRouteId: "/assetsroute/getallassetsbyrouteid",
    create: "/assetsroute/create",
    update: "/assetsroute/update",
    delete: "/assetsroute/delete",
    enable: "/assetsroute/enable",
    disable: "/assetsroute/disable",
    bulkinsert: "/assetsroute/bulkinsert",
  },
  inspSchedule: {
    title: "Inspection Schedule",
    link: "/inspection/getall",
    create: "/inspection/create",
    update: "/inspection/update",
    delete: "/inspection/delete",
    getByid: "/inspection/getbyid",
    enable: "/inspection/enable",
    disable: "/inspection/disable",
    generateworkorder: "/inspection/generateworkorder",
    getdocumentbyinsid: "/inspection/getdocumentbyinsid",
    uploaddocument: "/inspection/uploaddocument",
    downloaddocument: "/inspection/downloaddocument",
    deletedocument: "/inspection/deletedocument",
  },
  inspWo: {
    title: "Inspection WorkOrder",
    link: "/inspectionworkorders/getall",
    create: "/inspectionworkorders/create",
    update: "/inspectionworkorders/update",
    delete: "/inspectionworkorders/delete",
    getByid: "/inspectionworkorders/getbyid",
    enable: "/inspectionworkorders/enable",
    changeStatus: "/inspectionworkorders/updatestatus",
    getdocumentbyinsworkorderid:
      "/inspectionworkorders/getdocumentbyinsworkorderid",
    disable: "/inspectionworkorders/disable",
    uploaddocument: "/inspectionworkorders/uploaddocument",
    bulkinsert: "/inspectionworkorders/bulkinsert",
    deletedocement: "/inspectionworkorders/deletedocement",
    downloaddocument: "/inspectionworkorders/downloaddocument",
    bulkupdate: "/inspectionworkorders/bulkupdate",
    getInspectionWo: "/inspectionworkorders/getquestions",
    getQuestionByInsWo: "/inspectionworkorders/getallquestions",
  },
  inspWoLabour: {
    title: "Inspection WorkOrder Labour",
    link: "/inspectionworkorderlabours/getall",
    create: "/inspectionworkorderlabours/create",
    update: "/inspectionworkorderlabours/update",
    delete: "/inspectionworkorderlabours/delete",
    getByid: "/inspectionworkorderlabours/getbyid",
    enable: "/inspectionworkorderlabours/enable",
    disable: "/inspectionworkorderlabours/disable",
    getLabourByIWid:
      "/inspectionworkorderlabours/getlabourbyinspectionworkorderid",
    bulkinsert: "/inspectionworkorderlabours/bulkinsert",
  },
  partmovement: {
    title: "Parts Movement",
    link: "/partmovement/getall",
    enable: "/partmovement/enable",
    disable: "/partmovement/disable",
    create: "/partmovement/create",
    update: "/partmovement/update",
    bulkStatusUpdate: "/partmovement/bulkStatusUpdate",
    getTransferTransactionHistroy: "/partmovement/getTransferTransactionHistroy",
  },
  LineChart: {
    lineChartGraph: "Asset Health",
    lineValue: "Graph Value",
    iotInsertData: "/workorder/iotbulkinsert",
    getIotData: "/workorder/getiotdata",
  },
  currency: {
    title: "Currency",
    link: "/currency/getall",
    create: "/currency/create",
    update: "/currency/update",
    delete: "/currency/delete",
    getByid: "/currency/getbyid",
    enable: "/currency/enable",
    disable: "/currency/disable",
    getallcountrycurrencylist: "/currency/getallcountrycurrencylist",
  },
  shift: {
    title: "Shift",
    link: "/shift/getall",
    create: "/shift/create",
    update: "/shift/update",
    delete: "/shift/shiftbreakdelete",
    getByid: "/shift/getbyid",
    enable: "/shift/enable",
    disable: "/shift/disable",
  },
  userGroup: {
    title: "User Group",
    link: "/usergroup/getall",
    create: "/usergroup/create",
    update: "/usergroup/update",
    delete: "/usergroup/delete",
    getByid: "/usergroup/getbyid",
    enable: "/usergroup/enable",
    disable: "/usergroup/disable",
  },
  notificationcategory: {
    title: "Notification Category",
    link: "/notificationcategory/getall",
    create: "/notificationcategory/create",
    update: "/notificationcategory/update",
    delete: "/notificationcategory/delete",
    getByid: "/notificationcategory/getbyid",
    enable: "/notificationcategory/enable",
    disable: "/notificationcategory/disable",
  },
  usergroupnotificationcategory: {
    title: "User Group Notification Category Mapping",
    link: "/usergroupnotificationcategory/getall",
    create: "/usergroupnotificationcategory/create",
    update: "/usergroupnotificationcategory/update",
    delete: "/usergroupnotificationcategory/delete",
    getByid: "/usergroupnotificationcategory/getbyid",
    enable: "/usergroupnotificationcategory/enable",
    disable: "/usergroupnotificationcategory/disable",
  },
  usergroupwithroleanddepartment: {
    title: "User Group with Role and Person Mapping",
    link: "/usergroupwithroleanddepartment/getall",
    create: "/usergroupwithroleanddepartment/create",
    update: "/usergroupwithroleanddepartment/update",
    delete: "/usergroupwithroleanddepartment/delete",
    getByid: "/usergroupwithroleanddepartment/getbyid",
    enable: "/usergroupwithroleanddepartment/enable",
    disable: "/usergroupwithroleanddepartment/disable",
  },
  usergrouproledeptwithperson: {
    title: "User Group Role Department With Person Mapping",
    link: "/usergrouproledeptwithperson/getall",
    create: "/usergrouproledeptwithperson/create",
    update: "/usergrouproledeptwithperson/update",
    delete: "/usergrouproledeptwithperson/delete",
    getByid: "/usergrouproledeptwithperson/getbyid",
    enable: "/usergrouproledeptwithperson/enable",
    disable: "/usergrouproledeptwithperson/disable",
  },
  notificationtemplate: {
    title: "Notification Template",
    link: "/notificationtemplate/getall",
    create: "/notificationtemplate/create",
    update: "/notificationtemplate/update",
    delete: "/notificationtemplate/delete",
    getByid: "/notificationtemplate/getbyid",
    enable: "/notificationtemplate/enable",
    disable: "/notificationtemplate/disable",
    templatefiles: "/notificationtemplate/templatefiles",
  },
  department: {
    title: "Department",
    link: "/department/getall",
    create: "/department/create",
    update: "/department/update",
    delete: "/department/delete",
    getByid: "/department/getbyid",
    enable: "/department/enable",
    disable: "/department/disable",
  },
  templatefile: {
    title: "Template File",
    link: "/templatefile/getall",
    create: "/templatefile/create",
    update: "/templatefile/update",
    delete: "/templatefile/delete",
    getByid: "/templatefile/getbyid",
    enable: "/templatefile/enable",
    disable: "/templatefile/disable",
  },
  userGroupWithRoleandDepartmentWithListofRoles: {
    title: "User Group With Role and Department With List of Roles",
    link: "/userGroupWithRoleandDepartmentWithListofRoles/getall",
    create: "/userGroupWithRoleandDepartmentWithListofRoles/create",
    update: "/userGroupWithRoleandDepartmentWithListofRoles/update",
    delete: "/userGroupWithRoleandDepartmentWithListofRoles/delete",
    getByid: "/userGroupWithRoleandDepartmentWithListofRoles/getbyid",
    enable: "/userGroupWithRoleandDepartmentWithListofRoles/enable",
    disable: "/userGroupWithRoleandDepartmentWithListofRoles/disable",
  },
  userGroupWithRoleandDepartmentWithListofPerson: {
    title: "User Group With Role and Department With List of Person",
    link: "/userGroupWithRoleandDepartmentWithListofPerson/getall",
    create: "/userGroupWithRoleandDepartmentWithListofPerson/create",
    update: "/userGroupWithRoleandDepartmentWithListofPerson/update",
    delete: "/userGroupWithRoleandDepartmentWithListofPerson/delete",
    getByid: "/userGroupWithRoleandDepartmentWithListofPerson/getbyid",
    enable: "/userGroupWithRoleandDepartmentWithListofPerson/enable",
    disable: "/userGroupWithRoleandDepartmentWithListofPerson/disable",
  },
  calendarView: {
    title: "Calendar View",
    getAlreadyAssignedWO: "/workorder/getWorkorderAlreadyAssigned",
    getWorkorderNotAssigned: "/workorder/getWorkorderNotAssigned",
    updatePlannedDate: "/workorder/updatePlannedDateForCalender",
  },
  orgMenus: {
    getByOrgId: "/orgMenus/getMenuByOrg",
    delete: "/orgMenus/delete",
  },
  licence: {
    getall: "/licenceMaster/getall",
    create: "/licenceMaster/create",
    edit: "/licenceMaster/update",
    delete: "/licenceMaster/delete",
    enable: "/licenceMaster/enable",
    disable: "/licenceMaster/disable",
    licenceUserType: "/licenceUserType/getall",
  },
  licenceMenu: {
    getMenuByLicence: "/licenceMenus/getallMenusByLicenceUserTypeId",
  },
  licenceMenus: {
    delete: "/licenceMenus/delete",
  },
  licenceUserType: {
    title: "Licence User Type",
    link: "/licenceUserType/getall",
    create: "/licenceUserType/create",
    update: "/licenceUserType/update",
    delete: "/licenceUserType/delete",
    enable: "/licenceUserType/enable",
    getById: "/licenceUserType/getbyid",
    disable: "/licenceUserType/disable",
  },
  master_model: {
    title: "Model",
    link: "/modelmaster/getall",
    create: "/modelmaster/create",
    update: "/modelmaster/update",
    delete: "/modelmaster/delete",
    enable: "/modelmaster/enable",
    disable: "/modelmaster/disable",
    getModelbyAssetType: "/modelmaster/getmodelbyassettype",
    getModelById: "/modelmaster/getbyid",
  },
  model_spec_attributes: {
    title: "Model Spec Attributes",
    link: "/modelspecattributes/getall",
    create: "/modelspecattributes/create",
    update: "/modelspecattributes/update",
    delete: "/modelspecattributes/delete",
    enable: "/modelspecattributes/enable",
    disable: "/modelspecattributes/disable",
    getAllByModelId: "/modelspecattributes/getallbymodelid",
    bulkinsert: "/modelspecattributes/bulkinsert",
  },
  component: {
    title: "Component Profile",
    link: "/componentprofiles/getall",
    create: "/componentprofiles/create",
    update: "/componentprofiles/update",
    delete: "/componentprofiles/delete",
    enable: "/componentprofiles/enable",
    disable: "/componentprofiles/disable",
    getComponentByassetId: "/componentprofiles/getcomponentsbyassetid",
  },
  componentItem: {
    title: "Component Profile Item",
    link: "/componentprofileitems/getall",
    create: "/componentprofileitems/create",
    update: "/componentprofileitems/update",
    delete: "/componentprofileitems/delete",
    enable: "/componentprofileitems/enable",
    disable: "/componentprofileitems/disable",
    getComponentItemByComId:
      "/componentprofileitems/getallbycomponentprofileid",
  },
  partsReservation: {
    link: "/partsReservation/getall",
    bulkinsert: "/partsreservation/bulkinsert",
    update: "/partsreservation/update",
    enable: "/partsreservation/enable",
    create: "/partsreservation/create",
    disable: "/partsreservation/disable",
    getByWorkOrderId: "/partsreservation/getbyworkorderid",
    deleteParts: "/partsreservation/deleteparts",
    getPartReservationItems: "/partsreservation/getPartReservationItems",
    getPartReservationById: "/partsreservation/GetPartReservationById",
  },
};
